import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";

import { AdminShell } from "@/components/admin/admin-shell";
import { PlanForm, emptyPlan } from "@/components/admin/plan-form";

export const Route = createFileRoute("/admin/plans/new")({
  head: () => ({
    meta: [
      { title: "Create Plan — Spayzo Admin" },
      { name: "description", content: "Create a new subscription plan." },
    ],
  }),
  component: Page,
});

function Page() {
  const { t } = useTranslation();
  return (
    <AdminShell title={t("adminPlanForm.createPlan")} subtitle={t("adminPlanForm.newPlanSubtitle")}>
      <PlanForm mode="new" initial={emptyPlan} />
    </AdminShell>
  );
}
